import React from 'react';
import PieChart from '../../../../shared/pie-chart';
import WhiteContainer from '../../../../shared/white-container';


interface IPieChartDetails {
    stats: any;
    totalSessions?: number;
}

let chartData = [
    { name: 'Success', dbName: 'completed', value: 0 },
    { name: 'In Progress', dbName: 'inProgress', value: 0 },
    { name: 'Failed', dbName: 'failed', value: 0 },
    { name: 'Manual Review', dbName: 'manualReview', value: 0 },
]

const PieChartDetails = ({
    stats,
    totalSessions
}: IPieChartDetails) => {

    chartData = chartData?.map((data) => {
        return {
            ...data,
            value: stats?.[data?.dbName] || 0
        }
    })

    return (
        <WhiteContainer type='rounded'>
            <div>
                <div className='flex flex-row justify-start'>
                    <p className='pl-2 font-bold mb-2'>Session End States</p>
                </div>
                <PieChart
                    chartData={chartData}
                    totalSessions={totalSessions}
                />
            </div>
        </WhiteContainer>
    )
}

export default PieChartDetails;